import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

interface IAppVersionResponse {
  version?: string;
}

@Injectable({
  providedIn: 'root',
})
export class AppVersionService {
  private static readonly VERSION_ENDPOINT = 'assets/version.json';

  constructor(private readonly httpClient: HttpClient) {}

  public fetchLatestVersion(options?: { bustCache?: boolean }): Observable<string> {
    const params = options?.bustCache ? new HttpParams({ fromObject: { _ts: Date.now().toString() } }) : undefined;

    const headers = new HttpHeaders({ 'X-Skip-Loader': 'true' });

    return this.httpClient.get<IAppVersionResponse>(AppVersionService.VERSION_ENDPOINT, { params, headers }).pipe(
      map((response) => response?.version ?? ''),
      catchError((error) => {
        console.warn('Unable to retrieve remote app version', error);
        return of('');
      }),
    );
  }
}
